export default __webpack_public_path__ + "media/zurb/img/events/wired/lsa/life-services-image2-070550459aa12557b078f9ad6c891e3f.png";